import { useContext } from 'react'
import { Navigate } from 'react-router-dom'

import AuthContext from './AuthContext'
import { getToken } from './index'

// eslint-disable-next-line react/prop-types
const ProtectedRoute = ({ children, accessBy }) => {
  const { user, isRefreshing } = useContext(AuthContext)

  // While token refresh is in progress, show a loading state instead of redirecting
  if (isRefreshing) {
    return (
      <div className="pt-3 text-center min-vh-100 d-flex flex-column justify-content-center align-items-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
        <div className="mt-3 text-muted">Authenticating...</div>
      </div>
    )
  }

  if (accessBy === 'non-authenticated') {
    if (!user) {
      return children
    }
  } else if (accessBy === 'authenticated') {
    if (user) {
      return children
    }
  }
  const token = getToken()
  let path = '/login'
  if (token) {
    path = '/dashboard'
  }

  return <Navigate to={path}></Navigate>
}

export default ProtectedRoute

